<template>
    <div class="spa">
        <div class="treatments">
            <div v-if="currentTreatment == null">
                <h2>Room {{activeLeg.leg}}: {{activePackage.content.DisplayName}} </h2>
            </div>
            <div v-else>
                <h2>Room {{activeLeg.leg}}: {{activePackage.content.DisplayName}}</h2>
                <h2> {{currentTreatment.DisplayName}} </h2>
            </div>


            <div v-if="isLoading"
                 class="position-relative d-flex justify-content-center">
                <loader v-bind:message="'Preparing to unwind…'"></loader>

            </div>
            <div v-else>

  

                <div class="row justify-content-center mb-4">
                    <div class="col-24 col-xl-12">

                        <info-box v-bind:type="'alert'">

                            <template v-slot:body>
                                <p>All guests must attend the Spa Garden together.</p>

                            </template>
                        </info-box>
                    </div>
                </div>

                <div class="row justify-content-center text-start">
                    <div class="col-24 col-xl-10 bg-white has-shadow p-5">
                        <h3>Booking</h3>

                        <div class="booking-selection">
                            <label class="mb-2">Names</label>

                            <div v-for="(guest, gi) in guests">
                                <input type="text" style="background: white;" class="form-control mb-2" readonly v-bind:value="guest.firstName" />
                            </div>

                           
                            <div v-if="availableTimes == null || !availableTimes.length" class="mb-2">

                                <info-box v-bind:type="'error'">

                                    <template v-slot:body>
                                        <p>Sorry, we have no availability.</p>

                                    </template>
                                </info-box>
                            </div>

                        </div>


                        <div class="booking-selection" >
                            <label class="mb-2">Entry Time</label>

                            <select class="form-select mb-2" v-model="selectedTime">
                                <option disabled="disabled" value="">Please select...</option>
                                <option v-for="(item, ai) in availableTimes" v-bind:value="ai">{{formatTime(item.StartDateTime)}}</option>

                            </select>

                        </div>
                    </div>

                </div>


                <div class=" g-0 actions">

                    <div class="row mt-8 d-flex ">

                        <div class="col-12 d-flex justify-content-start">
                            <button class="btn btn--transparent btn--back" type="button" v-on:click="onClose()">
                                Cancel
                            </button>

                        </div>


                        <div class="col-12 d-flex justify-content-end" v-if="!isLoading">
                            <button class="btn btn--slate-blue btn--continue d-xl-block"  type="button" v-on:click="onSubmit()">
                                Done
                            </button>

                        </div>
                    </div>
                </div>

            </div>
        </div>



    </div>

</template>

<script>


    import InfoBox from '@/shared/components/InfoBox.vue';
    import Loader from '@/shared/components/Loader.vue';

    import spaapi from '@/shared/api/spa';
    import stayapi from '@/shared/api/stay';


    export default {
        name: 'PackageSpaGardenAvailability',
        props: {
            activeLeg: Object,
            activePackage: Object,
            activeBooking: Object
        },
        components: {
            InfoBox,
            Loader
        },
        data() {
            return {
                guests: [],
                innerAvailability: [],
                isLoading: false,
                selectedTime: '',

            }
        },
        mounted() {
            let o = this;

            o.isLoading = true;
         
            let codes = this.activePackage.content.SpaGardenTreatments;
      
            let arrival = moment(this.booking.arrivalDate);



            var payload = {
                date: arrival.format('YYYY-MM-DD'),
                groupExtras: codes.Durations.map(function (c) {
                    return c.Id;
                })
            };

            spaapi.getExtras(payload, (t) => {
                o.innerAvailability = t.Groups.find(item => item.Key == payload.groupExtras[0]);


                this.guests.push({
                    guestIndex: 0,
                    firstName: this.activeLeg.LeadGuest.FirstName,
                    mudAccess: true,
                    isPrimary: true
                })



                if (this.activeLeg.AccompanyingGuests != null && this.activeLeg.AccompanyingGuests.length) {


                    for (let i = 0; i < this.activeLeg.AccompanyingGuests.length; i++) {
                        let guest = this.activeLeg.AccompanyingGuests[i];

                        this.guests.push({
                            guestIndex: (i + 1),
                            firstName: guest.FirstName,
                            mudAccess: true,
                            isPrimary: false
                        })

                    }

                }


                o.isLoading = false;
            });



        },
        computed: {
            booking() {
                return this.activeBooking;
            },
            selectedAvailability() {
                let availableTimes = this.availableTimes;
   
                if (availableTimes != null) {
                    let selectedItem = availableTimes[+(this.selectedTime)];
                    return selectedItem;
                }
                return null;
            },
        
        
            availableTimes() {
               
               
                    let availabileTimes = this.innerAvailability;
                    
                    return availabileTimes.Items;

              
            }
        },

        methods: {
            onClose() {
                this.$parent.$emit('close');
            },
            onSubmit() {
                let o = this;
                
                if (this.selectedAvailability == null) {
                    this.onClose();
                    return;
                }

                let payload = {
                    item: o.activePackage,
                    leg: o.activeLeg.leg,
                    quantity: 1,
                    isSpaGarden: true,
                    selections: [{
                        price: 0,
                        guestIndexes: this.guests.map(function (item) { return item.guestIndex; }),
                        code: this.activeCode,
                        selection: this.selectedAvailability,
                        addOn: this.activePackage
                    }]


                };
              
                payload.item.availability.AmountOverride = payload.selections[0].selection.ActualPrice;




                store.dispatch('selectPackage', payload).then(() => {
                    this.$parent.$emit('close');

                });
            },

            formatTime(dateTime) {
                let date = moment(dateTime);
                return date.format("HH:mm");
            },
        
        },
    }
</script>

<style scoped>

    .spa-day-treatment-item {
        min-height: 250px;
        margin-bottom: 20px;
        height: calc(100% - 20px);
    }

    .player-count {
        font-size: 14px;
        text-transform: uppercase;
        text-align: left;
        font-weight: bold;
    }

    .time-date-day,
    .time-date-year {
        display: block;
        width: 100%;
        font-size: 14px;
        text-transform: uppercase;
        text-align: left;
        cursor: pointer;
    }

    .time-date-day {
        font-weight: bold;
    }

    .time-date-year {
        font-weight: 400;
    }

    .date-panel {
        background: #fff;
        cursor: pointer;
    }


        .date-panel.on {
            background: #425260;
            color: #fff;
        }

        .date-panel input[type="checkbox"] {
            height: 24px;
            width: 24px;
            position: relative;
            top: 4px;
            cursor: pointer;
        }

    .time-slot {
        padding: 15px;
        display: block;
        background: white;
        border-radius: 5px;
        margin-bottom: 20px;
        cursor: pointer;
    }


        .time-slot.time-slot--unavailable {
            color: rgba(66, 82, 96, 0.15);
            cursor: not-allowed;
        }


        .time-slot:not(.time-slot--unavailable):hover,
        .time-slot.time-slot--active {
            background-color: #425260;
            color: #fff;
        }

    .timeslot--disabled,
    .timeslot--disabled:hover {
        background: #ddd !important;
        color: #000 !important;
        cursor: default;
    }



    .date-selector {
        font-size: 14px;
        font-family: Montserrat;
    }



    .modal-button {
        background-color: #fff;
        position: relative;
        color: #000;
        border-color: #fff;
        margin-bottom: 30px !important;
    }


        .modal-button:after {
            border-top: 10px solid #fff;
            display: block;
            position: absolute;
            content: ' ';
            bottom: -11px;
            left: 50%;
            transform: translateX(-50%);
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            z-index: 10;
        }



    .modal-botton:hover,
    .modal-button--active {
        background-color: #425260;
        border-color: #425260;
        color: #fff;
    }

        .modal-botton:hover,
        .modal-button--active:after {
            border-top: 10px solid #425260;
        }


    .spa-day-treatment-item {
        min-height: 250px;
    }

    .treatment-price {
        position: absolute;
        right: 0;
        font-weight: bold;
        top: 0;
    }


    .spa-day-treatment-item h4 {
        font-size: 24px;
    }

    .spa-day-treatment-item .gallery {
        height: 250px;
    }


    .spa .treatments .item-wrapper {
        display: flex;
        flex-direction: column;
        text-align: start;
    }

    .spa .treatments .item-description {
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 15px;
        margin-bottom: 10px;
        flex-grow: 1;
    }

        .spa .treatments .item-description.on {
            height: auto;
        }

    .spa .treatments .view-more {
        background: none;
        border: none;
        margin-bottom: 5px;
        display: flex;
        align-self: flex-end;
    }



    .spa .treatments .modal-content {
        max-width: none;
    }

    .spa .treatments .btn-treatment {
        border: none;
        margin-right: 5px;
        padding: 15px;
        background: #eae5e3;
        text-transform: capitalize;
        min-width: 100px !important;
    }

        .spa .treatments .btn-treatment:hover {
            color: #fff;
            background: #425260;
        }


        .spa .treatments .btn-treatment:disabled {
            color: #000;
            cursor: not-allowed !important;
        }


        .spa .treatments .btn-treatment.on:disabled {
            background: #425260;
            color: #fff;
        }

    .spa .treatments .treatment-name {
        font-size: 14px;
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
    }

    .spa .treatments .treatment-duration {
        font-size: 14px;
        display: block;
        font-weight: 300;
    }

    .spa .treatments .btn-edit {
        border: none;
        background-color: transparent;
        position: absolute;
        right: 0%;
        top: 0%;
        height: 15px;
        text-indent: -9999px;
        width: 15px;
        background-position: center center;
        background-size: 15px 15px;
        background-repeat: no-repeat;
        background-image: url(/Assets/img/website/modal-close.svg);
        position: absolute;
        top: 15px;
        right: 15px;
    }


    .spa .modal-body {
        overflow-y: scroll;
        height: 800px;
    }

    .spa .treatment-selection {
        padding: 20px;
        border-radius: 2px;
        background-color: #eae5e3;
        color: #333;
        font-size: 14px;
        font-family: Montserrat;
        position: relative;
        margin-bottom: 20px;
    }

    .guests-title {
        display: block;
        width: 100%;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 14px;
        text-transform: uppercase;
        text-align: center;
        font-family: Montserrat;
        margin-bottom: 10px;
    }


    .spa .treatment-selection-reset {
        text-indent: -9999px;
        position: relative;
        right: 7px;
        top: 3px;
        border: none;
        height: 15px;
        width: 15px;
        background-size: 15px 15px;
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url(/Assets/img/website/modal-close.svg);
        background-color: transparent;
    }


    .spa .treatment-selection-title {
        font-weight: bold;
        display: block;
    }

    .spa .treatment-selection-detail {
        font-weight: 300;
    }

    .spa .treatment-selection ul {
        list-style: none;
        padding: 0;
        margin-bottom: 0;
    }

    .spa .treatments .spa-intro a {
        font-weight: bold;
        color: #a2905b;
    }

    .spa .treatments .spa-intro h3 {
        font-size: 24px;
    }

    .spa .treatments .spa-intro p {
        font-size: 16px;
    }

        .spa .treatments .spa-intro p:last-of-type {
            margin-bottom: 0;
        }

    .spa .modal-price {
        display: block;
        margin-top: 5px;
        font-weight: normal;
    }



    .spa .spa-total-label {
        font-weight: 300;
        display: block;
        font-size: 16px;
        text-align: center;
    }

    .spa .spa-total {
        font-weight: bold;
        display: block;
        font-size: 24px;
        text-align: center;
    }


    @media(max-width: 1199px) {
        .actions button {
            width: 100%;
        }
    }
</style>



<style scoped>
    .mud-name {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 16px;
        font-weight: bold;
        font-family: 'Montserrat'
    }

        .mud-name input[type=checkbox] {
            width: 30px;
            height: 30px;
            margin-right: 8px;
        }

    .booking-selection label {
        font-size: 14px;
        font-weight: bold;
        font-family: 'Montserrat'
    }
</style>